module.exports = "https://www.gc-qa.gnp.com.mx/48af353a57e8e161ba3c44853a850a1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg-video-11.png
// module id = 938
// module chunks = 0 1